import { PaginatedResponse } from "./paginated-response";

export class WorksheetStatusHistory extends PaginatedResponse {
    records: WorksheetStatus[] = [];
}
  
export class WorksheetStatus{
    worksheetId:string;
    worksheetName: string;
    projectId: string;
    projectName: string;
    marketName: string;
    initiatorId: string;
    initiatorName: string;
    initiatorTeamId: string;
    initiatorTeamName: string;
    approverId:string;
    approverName:string;
    lastModifiedDate:Date;
    status:string;
    isQuoted:string;
    orderNumber:string;
    needByDate:string;
    mrDate: Date;
    dateQuoted:Date;
    dateOrdered:Date;
    wsCreateDate:Date;
    approvalCreateDate:Date;
    approvalClosedDate:Date;
    designatedApprover:string;
    oracleProjectName:string;
    oracleProjectNumber:string;
    oracleSiteNumber:string; 
}
  
 


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/worksheet-status.ts